import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Outlines } from '@react-three/drei'

import MeshSound from '../MeshSound'

export default function Gramophone({ ...props }) {
  const { currentIndex } = useSelector((state) => state.progress)

  useEffect(() => {
    if (currentIndex === props.index && props.sceneAnims[2]) {
      props.sceneAnims[2].play()
    }
  }, [props.sceneAnims])

  return (
    <>
      <mesh
        name="Gramophone"
        geometry={props.nodes.Gramophone.geometry}
        material={props.material}
        onClick={props.onClick}
        onPointerEnter={props.onPointerEnter}
        onPointerLeave={props.onPointerLeave}
        position={[-5.047, 3.413, -1.434]}
        rotation={[0, 0, -Math.PI / 2]}
      >
        <mesh
          name="Vinyl"
          geometry={props.nodes.Vinyl.geometry}
          material={props.material}
          position={[1.343, 4.958, 4.01]}
        />
        <Outlines
          thickness={props.outline && currentIndex === props.index ? 0.003 : 0}
          color="white"
        />
      </mesh>
      <MeshSound index={props.index} position={[0, 2.2, 2.2]} />
    </>
  )
}
